import { useEffect, useState } from "react"

import Modal from "shared/components/modal"
import SignUpAndPurchase from "app/components/subscriptions/sign_up_and_purchase"
import "./modal.scss"
import { captureMessage } from "@sentry/react"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import { saveUserPermissions } from "shared/scripts/new_badge_button.tsx"

interface Props {
  locationType: string
  modalSubscriptionUrl: string
  newProPlusSubscriptionUrl: string
  newProSubscriptionUrl: string
  onClose: object
  onUpgrade: object
  target: string
  visible: boolean
}

const CheckoutModal = ({ locationType, modalSubscriptionUrl, newProPlusSubscriptionUrl, newProSubscriptionUrl, onClose, onUpgrade, target, visible }: Props) => {
  const [subscriptionProps, updateSubscriptionProps] = useState({
    loaded: false,
  })

  const loadSubscriptionProps = () => {
    fetch(modalSubscriptionUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      redirect: "error",
    })
      .then(response => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status)
        }

        return response.json()
      })
      .then(result => {
        updateSubscriptionProps({
          ...result,
          loaded: true,
        })
      })
  }

  useEffect(() => {
    loadSubscriptionProps()
  }, [])

  useEffect(() => {
    if (visible && !subscriptionProps.loaded) {
      // In case that we have an issue load data to be used in SignUpAndPurchase, not block user. Redirect them to checkout page.
      captureMessage(
        "Checkout modal failed to load subscription data and redirect user to checkout page.",
        { tags: { user_id: window.App.userId }, extra: { target } }
      )
      window.location.assign(target === "intermediate_pro" ? newProSubscriptionUrl : newProPlusSubscriptionUrl)
    }
  }, [visible])

  const onCloseHandleClick = () => {
    logIFTTTNextAction("click", {
      object_type: "checkout_inline",
      object_id: "cancel_button",
      location_type: locationType
    })
    onClose()
  }

  return (
    subscriptionProps.loaded && (
      <div styleName="modal-container checkout-on-modal" className="checkout-on-modal">
        <Modal show={visible} includeCloseX={false}>
          <>
            <SignUpAndPurchase
              productId={subscriptionProps[target]["product_id"]}
              tier={subscriptionProps[target]["tier"]}
              planId={subscriptionProps[target]["plan_id"]}
              monthlyPlan={subscriptionProps[target]["monthly_plan"]}
              yearlyPlan={subscriptionProps[target]["yearly_plan"]}
              assets={subscriptionProps["assets"]}
              eligibleForTrial={subscriptionProps["eligible_for_trial"]}
              browserType={subscriptionProps["browser_type"]}
              email={subscriptionProps["email"]}
              referrerPath={window.location.href}
              subscriptionsPath={subscriptionProps["subscriptions_path"]}
              createStripeCustomerUrl={
                subscriptionProps["create_stripe_customer_url"]
              }
              initialPromoCode={subscriptionProps["initial_promo_code"]}
              renderingInsideModal={true}
              onModalHandleSuccessfulSubscription={_subscription => {
                window.appendFlash(
                  "Upgrade complete. Welcome to IFTTT Pro!",
                  "success"
                )
                const isProPlus = subscriptionProps[target]["tier"] == "pro"
                saveUserPermissions(subscriptionProps[target]["tier"], {
                  multi_action: { permitted: true },
                  filter_code: { permitted: isProPlus },
                  queries: { permitted: isProPlus },
                  multi_service_account: { permitted: isProPlus },
                })
                onUpgrade()
                onClose()
              }}
              // props not used in modal mode
              subscriptionSuccessPath=""
              redirectToMobileAppOnSuccess={false}
              campaignId={null}
            />
          </>
          <a
            className="link-standalone mt2"
            styleName="cancel-link"
            onClick={onCloseHandleClick}
          >
            Maybe later
          </a>
        </Modal>
      </div>
    )
  )
}

export default CheckoutModal
